.header {
    justify-content: space-between;
    align-items: baseline;
    border-radius: 8px;
}

.container {
    border-radius: 8px;
    padding: 8px 14px 16px 14px;
    &:hover {
        opacity: 0.8;
        transform: opacity;
        transition: 0.3s ease-out;
        cursor: pointer;
    }
    border-bottom: solid 1px var(--mantine-color-dark-4);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
